export default __webpack_public_path__ + "static/what-americas-want-fefdf2dab3aa4c6e3bf494a2ec8dbb3a.png";